var map = {
	"./epub-ic.png": "a45f",
	"./folder-ic.png": "3876",
	"./pdf-ic.png": "4166",
	"./png-ic.png": "d7d8",
	"./txt-ic.png": "7e1e",
	"./viwoods-ic.png": "07bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b79b";